export const setUnvisitedPlacesCount = ({ placeCount, isLoading }) => state => {
  return {
    ...state,
    unvisitedPlaces: {
      ...state.unvisitedPlaces,
      pagination: {
        ...state.unvisitedPlaces.pagination,
        isLoading:
          isLoading === undefined
            ? state.unvisitedPlaces.pagination.isLoading
            : isLoading,
        itemCount: placeCount,
        pageCount: Math.ceil(
          placeCount / state.unvisitedPlaces.pagination.pageSize,
        ),
      },
    },
  };
};
